import PropTypes from "prop-types";
import React from "react";
import { Button } from "react-bootstrap";
import { useIntl } from "react-intl";

import genericTranslations from "../utils/genericTranslations.js";

import Pagination from "./Pagination";

const styles = {
  footerWrapper: {
    display: "flex",
    marginTop: "1rem",
    marginBottom: "1rem",
  },
  footerInnerWrapper: {
    width: "50%",
  },
  footerInerWrapperRight: {
    width: "50%",
    textAlign: "right",
  },
};

const TableFooter = ({ actionPath, onSelectPage, page, pages }) => {
  const intl = useIntl();

  return (
    <div style={styles.footerWrapper}>
      <div style={styles.footerInnerWrapper}>
        {pages > 1 && (
          <Pagination
            first
            prev
            last
            next
            ellipsis
            boundaryLinks
            maxButtons={5}
            onSelect={onSelectPage}
            page={page}
            pages={pages}
          />
        )}
      </div>
      {actionPath && (
        <div style={styles.footerInerWrapperRight}>
          <Button variant="primary" href={actionPath}>
            {intl.formatMessage(genericTranslations.add)}
          </Button>
        </div>
      )}
    </div>
  );
};

TableFooter.propTypes = {
  actionPath: PropTypes.string,
  onSelectPage: PropTypes.func,
  page: PropTypes.number,
  pages: PropTypes.number,
};

export default TableFooter;
